exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-container[data-v-60d8bd1e] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: 100vh;\n  width: 100%;\n  z-index: 1000;\n  background: #000;\n  opacity: 0.7;\n}\n.loading-container .loading[data-v-60d8bd1e] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);

// exports
